/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStepCheckupSuggestionsAliases {
  CARD_CONTAINER_BODY_SUGGESTION = 'card-container-body-suggestion',
  CARD_CONTAINER_HEADER_SUGGESTION = 'card-container-header-suggestion',
  CARD_CONTAINER_SUGGESTION = 'card-container-suggestion',
  CARD_CONTAINER_ZONE_DATE = 'card-container-zone-date',
  CARD_CONTAINER_ZONE_ESTABLISHMENT = 'card-container-zone-establishment',
  CARD_CONTAINER_ZONE_SECTOR = 'card-container-zone-sector',
  DATE_PICKER_SCHEDULE_RANGE = 'date-picker-schedule-range',
  DECK_SUGGESTION_GROUPS = 'deck-suggestion-groups',
  FIELD_DATE = 'field-date',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_SECTOR = 'field-sector',
  ICON_CHECKUP_SUGGESTION = 'icon-checkup-suggestion',
  LAYOUT_SUGGESTION = 'layout-suggestion',
  LAYOUT_SUGGESTIONS = 'layout-suggestions',
  LOADER = 'loader',
  MAPPER_CHECKUP_SUGGESTION = 'mapper-checkup-suggestion',
  PANEL_LOADER = 'panel-loader',
  PANEL_SUGGESTION_GROUPS = 'panel-suggestion-groups',
  PANEL_SUGGESTION_LIST = 'panel-suggestion-list',
  PANEL_WEEK_DAYS = 'panel-week-days',
  TEXT_DATE = 'text-date',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_SECTOR = 'text-sector',
}
export { PseudonymAppointmentsStepCheckupSuggestionsAliases };
